import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "img-wrapper" }
const _hoisted_2 = {
  playsinline: "",
  autoplay: "",
  muted: "",
  loop: ""
}
const _hoisted_3 = ["src"]




export default /*#__PURE__*/_defineComponent({
  __name: 'videoComponent',
  props: {
    src: {},
    class: {},
    description: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", _hoisted_2, [
      _createElementVNode("source", {
        src: props.src,
        type: "video/mp4",
        class: _normalizeClass(props.class)
      }, null, 10, _hoisted_3)
    ])
  ]))
}
}

})